import { SubscriptionStatus } from '@aibees/shared/definition';
import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';

export function usePaymentStatus() {
  const { data } = useCurrentSubscriptionApi();

  const paymentFailed = data?.current?.status === SubscriptionStatus.PAST_DUE;

  return { paymentFailed };
}
